import { useQuery } from "@tanstack/react-query";
import { RolePermissionsResponse } from "Models/resources";
import RoleService from "Services/role.service";

// enabled:  isOpenAccessRuleDrawer && !!currentUser?.id && !!accessRule?.id,

export const useAccessRuleDrawerActions = () => {
  const getAccesRules = (options: {
    enabled: boolean;
    accessRuleId?: number;
    onSuccess: (data: RolePermissionsResponse[]) => void;
  }) => {
    const { enabled, accessRuleId, onSuccess } = options;
    return useQuery(
      ["permissions.get-by-role"],
      () => RoleService.getPermissionsByRoleId(accessRuleId as number),
      {
        enabled,
        refetchOnWindowFocus: false,
        onSuccess: (response) => {
          if (!response?.data) return;
          onSuccess?.(response?.data);
        },
      }
    );
  };

  return {
    getAccesRules,
  };
};
